/* Collett v3 — lagen: menu, snel kopen, mandje, toast.
   Het mandje is het échte Shopify-mandje via de Ajax Cart API.
   Alle beweging is transform/opacity; CLS blijft 0.                        */
(() => {
  'use strict';

  const C = window.COLLETT || {};
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const rust = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const geld = (cent) => {
    const bedrag = (cent / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
    return '€' + bedrag;
  };

  /* ---------------- zichtbare hoogte van het venster ----------------
     De lades en de bevestiging staan op position:fixed. In een gewone browser
     is 100dvh daarvoor genoeg, maar in de in-app browsers van iOS (de pagina
     openen vanuit WhatsApp of Instagram) zweven de werkbalken óver de pagina:
     de kop van het mandje verdween achter de bovenbalk en de onderkant van de
     lade stopte een eind boven de onderkant van het scherm, met de pagina
     eronder gewoon in beeld (Jarno, 23-10-2026). visualViewport weet wél wat
     er werkelijk zichtbaar is. Die maten zetten we als variabelen; de CSS
     rekent ermee en valt terug op 100dvh als dit script niet draait. */
  const vv = window.visualViewport;
  const meetZicht = () => {
    const s = document.documentElement.style;
    const hoogte = Math.round(vv ? vv.height : window.innerHeight);
    const boven = Math.round(vv ? vv.offsetTop : 0);
    /* Wat er onder de zichtbare rand nog aan venster zit: in Safari de
       werkbalk, met een open toetsenbord het toetsenbord. Kan ook negatief
       zijn, als de browser de pagina groter opgeeft dan hij toont. */
    const onder = Math.round((window.innerHeight || hoogte) - (boven + hoogte));
    s.setProperty('--zichthoogte', hoogte + 'px');
    s.setProperty('--zichtboven', boven + 'px');
    s.setProperty('--zichtonder', onder + 'px');
  };
  meetZicht();
  if (vv) {
    vv.addEventListener('resize', meetZicht);
    vv.addEventListener('scroll', meetZicht);
  } else {
    addEventListener('resize', meetZicht);
  }
  addEventListener('orientationchange', () => setTimeout(meetZicht, 150));

  /* ---------------- lagen openen en sluiten ---------------- */
  let laatsteFocus = null;

  /* De pagina stil zetten zolang een lade openstaat. html{overflow:hidden}
     alleen houdt iOS niet tegen: daar scrolt de pagina achter het paneel door.
     Daarom zetten we de body vast op zijn huidige plek en zetten we hem bij
     het sluiten precies terug. */
  let vastY = 0;
  let staatVast = false;
  const zetVast = () => {
    if (staatVast) return;
    staatVast = true;
    vastY = window.scrollY || window.pageYOffset || 0;
    const b = document.body.style;
    document.documentElement.style.overflow = 'hidden';
    b.position = 'fixed';
    b.top = (-vastY) + 'px';
    b.left = '0';
    b.right = '0';
    b.width = '100%';
  };
  const maakLos = () => {
    if (!staatVast) return;
    staatVast = false;
    const b = document.body.style;
    b.position = '';
    b.top = '';
    b.left = '';
    b.right = '';
    b.width = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, vastY);
  };

  /* De panelen staan in de lagen-sectie, en die zet Shopify binnen <main>.
     Eerder zetten we <main> op inert zodra een paneel openging — waarmee het
     paneel zichzelf uitschakelde, want inert erft naar beneden en is op een
     kind niet terug te draaien. Gevolg: geen enkele tik in een paneel kwam
     aan. Met .click() in een script merk je dat niet, want dat slaat de
     hit-test over; een echte vinger wel.

     Daarom isoleren we nu van binnen naar buiten: loop van het paneel naar
     <body> en zet alleen de broers en zussen op inert. Alles buiten het paneel
     is onbereikbaar, het paneel zelf blijft gewoon werken. */
  let geisoleerd = [];

  const isoleer = (laag) => {
    const gewijzigd = [];
    let el = laag;
    while (el && el.parentElement) {
      for (const zus of el.parentElement.children) {
        if (zus !== el && !zus.inert) { zus.inert = true; gewijzigd.push(zus); }
      }
      if (el.parentElement === document.body) break;
      el = el.parentElement;
    }
    return gewijzigd;
  };

  const herstel = () => {
    geisoleerd.forEach((e) => { e.inert = false; });
    geisoleerd = [];
  };

  const openLaag = (id) => {
    const l = document.getElementById(id);
    if (!l) return;
    laatsteFocus = document.activeElement;
    meetZicht();
    l.setAttribute('data-open', '');
    herstel();
    geisoleerd = isoleer(l);
    zetVast();
    const eerste = l.querySelector('button, [href], input, select, textarea');
    if (eerste) setTimeout(() => eerste.focus({ preventScroll: true }), rust ? 0 : 160);
  };

  const sluitLaag = (l) => {
    if (!l) l = $('.laag[data-open]');
    if (!l) return;
    l.removeAttribute('data-open');
    herstel();
    /* Pas losmaken als er echt geen paneel meer openstaat. */
    if (!document.querySelector('.laag[data-open]')) maakLos();
    if (laatsteFocus && laatsteFocus.focus) laatsteFocus.focus({ preventScroll: true });
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-sluit]')) { sluitLaag(e.target.closest('.laag')); return; }
    if (e.target.closest('[data-menu]')) { openLaag('menu'); return; }
    /* Algemene opener: elke knop met data-laag="<id>" opent dat paneel, zodat
       de filter-, maat- en sorteerpanelen dezelfde inert-, Esc- en
       focusafhandeling krijgen in plaats van hun eigen halve kopie. */
    const laagKnop = e.target.closest('[data-laag]');
    if (laagKnop) { openLaag(laagKnop.dataset.laag); return; }
    if (e.target.closest('#mand') || e.target.closest('[data-open-mandje]')) {
      if (e.target.closest('[data-open-mandje]')) verbergToast();
      openLaag('mandje'); teken(); return;
    }
    const snel = e.target.closest('[data-snel]');
    if (snel) { e.preventDefault(); opensnel(snel.dataset.snel, snel); }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-toast-sluit]')) verbergToast();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && $('.laag[data-open]')) sluitLaag();
    if (e.key === 'Escape') verbergToast();
  });

  /* ---------------- bevestiging na toevoegen ----------------
     Laat zien wát er in het mandje ligt: foto, naam, maat en prijs van de
     regel die er net bij kwam. De regel wordt gezocht op het variant-id van de
     maat die net gekozen is; lukt dat niet, dan op dat van de knop, en pas als
     ook dat niets oplevert op de laatste regel in het mandje.

     Die laatste terugval is bewust het sluitstuk en niet de regel: Shopify zet
     een nieuwe regel niet altijd onderaan. Daardoor meldde de bevestiging een
     ander paar dan je net gekozen had — op een telefoon het vervelendste soort
     fout, want je ziet het mandje er niet naast (Jarno, 23-10-2026).
     Zie de toelichting in sections/v3-lagen.liquid. */
  let toastTimer = null;

  const verbergToast = () => {
    const t = $('#toast');
    if (!t) return;
    t.removeAttribute('data-open');
    clearTimeout(toastTimer);
  };

  const toastKlok = () => {
    clearTimeout(toastTimer);
    toastTimer = setTimeout(verbergToast, 6000);
  };

  const regelVanBron = (bron, variant) => {
    if (!mandje || !mandje.items || !mandje.items.length) return null;
    const id = Number(variant || (bron && (bron.dataset.variant || bron.dataset.pcVariant)) || 0);
    if (id) {
      const gevonden = mandje.items.find((r) => Number(r.variant_id) === id);
      if (gevonden) return gevonden;
    }
    return mandje.items[mandje.items.length - 1];
  };

  const toonBevestiging = (bron, variant) => {
    const t = $('#toast');
    const regel = regelVanBron(bron, variant);
    if (!t || !regel) return;

    const beeld = $('#toastbeeld');
    if (beeld) {
      beeld.innerHTML = regel.image
        ? `<img src="${regel.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="" loading="lazy">`
        : '';
    }
    const naam = $('#toastnaam');
    if (naam) naam.textContent = regel.product_title || regel.title || '';

    const meta = $('#toastmeta');
    if (meta) {
      const maat = (regel.variant_title || '').replace('Default Title', '').trim();
      meta.textContent = [maat, geld(regel.final_line_price)].filter(Boolean).join(' · ');
    }

    meetZicht();
    t.setAttribute('data-open', '');
    toastKlok();
  };

  /* Zolang je hem aanwijst of er met het toetsenbord in staat blijft hij staan:
     een melding die wegvalt terwijl je hem leest is erger dan geen melding. */
  const toastEl = $('#toast');
  if (toastEl) {
    toastEl.addEventListener('mouseenter', () => clearTimeout(toastTimer));
    toastEl.addEventListener('mouseleave', toastKlok);
    toastEl.addEventListener('focusin', () => clearTimeout(toastTimer));
    toastEl.addEventListener('focusout', toastKlok);

    /* Wegvegen op een aanraakscherm. */
    let vegenX = null, vegenY = null;
    toastEl.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      vegenX = e.touches[0].clientX;
      vegenY = e.touches[0].clientY;
    }, { passive: true });
    toastEl.addEventListener('touchend', (e) => {
      if (vegenX === null) return;
      const p2 = e.changedTouches && e.changedTouches[0];
      if (p2 && (Math.abs(p2.clientX - vegenX) > 60 || p2.clientY - vegenY > 50)) verbergToast();
      vegenX = null; vegenY = null;
    });
  }

  /* ---------------- teller ---------------- */
  const zetTeller = (n) => {
    const t = $('#teller'), knop = $('#mand');
    if (!t) return;
    t.textContent = n;
    t.toggleAttribute('data-aan', n > 0);
    if (n > 0) { t.classList.remove('bots'); void t.offsetWidth; t.classList.add('bots'); }
    if (knop) {
      knop.setAttribute('aria-label',
        n > 0 ? `Winkelmandje, ${n} ${n === 1 ? 'artikel' : 'artikelen'}` : 'Winkelmandje, leeg');
    }
  };

  /* ---------------- vliegen naar het mandje ---------------- */
  const vlieg = (bronEl) => {
    if (rust || !bronEl) return;
    const beeld = bronEl.closest('.kaart, .koop__kop, .laag__paneel')?.querySelector('img');
    const doel = $('#mand');
    if (!beeld || !doel) return;
    const b = beeld.getBoundingClientRect(), d = doel.getBoundingClientRect();
    const kloon = beeld.cloneNode();
    kloon.className = 'vlieger';
    Object.assign(kloon.style, {
      left: b.left + 'px', top: b.top + 'px', width: b.width + 'px', height: b.height + 'px'
    });
    document.body.appendChild(kloon);
    const dx = d.left + d.width / 2 - (b.left + b.width / 2);
    const dy = d.top + d.height / 2 - (b.top + b.height / 2);
    kloon.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: `translate(${dx * .45}px, ${dy * .45 - 60}px) scale(.55) rotate(-12deg)`, opacity: .9, offset: .55 },
      { transform: `translate(${dx}px, ${dy}px) scale(.08) rotate(-20deg)`, opacity: .4 }
    ], { duration: 750, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = () => kloon.remove();
  };

  /* ---------------- mandje ophalen en tekenen ---------------- */
  let mandje = null;

  const haalMandje = async () => {
    try {
      const r = await fetch(C.routes.mandje, { headers: { Accept: 'application/json' } });
      mandje = await r.json();
      zetTeller(mandje.item_count);
      return mandje;
    } catch (e) { return null; }
  };

  /* Het mandje wordt server-side gerenderd (snippets/v3-mandinhoud.liquid en
     v3-mandvoet.liquid, in de sectie v3-lagen) en na elke wijziging opnieuw
     opgehaald via de Section Rendering API. Dat is de enige manier om de
     voorraad per regel te tonen — cart.js geeft geen inventory_quantity — en
     het houdt de bedragen in de valuta-opmaak van de winkel.

     Mislukt het ophalen, dan blijft staan wat er stond: een leeg mandje tonen
     terwijl er iets in ligt is erger dan een regel die even niet meeloopt. */
  const teken = async () => {
    const inhoud = $('#mandinhoud'), voet = $('#mandvoet');
    if (!inhoud || !C.mandSectie) return;
    try {
      const url = `${location.pathname}?section_id=${encodeURIComponent(C.mandSectie)}`;
      const html = await fetch(url, { headers: { Accept: 'text/html' } }).then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      });
      const vers = new DOMParser().parseFromString(html, 'text/html');
      const versInhoud = vers.querySelector('#mandinhoud');
      const versVoet = vers.querySelector('#mandvoet');
      if (versInhoud) inhoud.innerHTML = versInhoud.innerHTML;
      if (voet && versVoet) voet.innerHTML = versVoet.innerHTML;
      aanbodPijlen();
    } catch (e) { /* laat staan wat er staat */ }
  };

  document.addEventListener('click', async (e) => {
    /* Eén maat? Dan gaat het paar meteen in het mandje, zonder paneel. */
    const los = e.target.closest('[data-mandje-los]');
    if (los) {
      los.disabled = true;
      try {
        await fetch(C.routes.toevoegen, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(los.dataset.mandjeLos), quantity: 1 }] })
        });
        const m = await fetch(C.routes.mandje, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        mandje = m;
        zetTeller(m.item_count);
        teken();
      } catch (err) { los.disabled = false; }
      return;
    }

    const stap = e.target.closest('[data-aantal]');
    if (stap) {
      const naar = Math.max(0, +stap.dataset.naar);
      stap.disabled = true;
      try {
        const r = await fetch(C.routes.wijzig, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: +stap.dataset.aantal, quantity: naar })
        });
        mandje = await r.json();
        zetTeller(mandje.item_count);
        teken();
      } catch (err) { stap.disabled = false; }
      return;
    }

    const weg = e.target.closest('[data-verwijder]');
    if (!weg) return;
    const regel = +weg.dataset.verwijder;
    weg.disabled = true;
    try {
      const r = await fetch(C.routes.wijzig, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: regel, quantity: 0 })
      });
      mandje = await r.json();
      zetTeller(mandje.item_count);
      teken();
    } catch (err) { weg.disabled = false; }
  });

  /* ---------------- snel kopen ---------------- */
  const cache = new Map();
  let gekozenVariant = null, gekozenBron = null, snelProduct = null;

  /* De prijs in het paneel: de echte prijs van de gekozen maat, want die kan per
     maat verschillen (02-11-2026). Zonder maat de laagste prijs, met "Vanaf"
     als er duurdere maten zijn. */
  const snelPrijs = (prijs, oud, vanaf) =>
    (vanaf ? 'Vanaf ' : '') + geld(prijs) +
    (oud && oud > prijs ? ` <s class="getal">${geld(oud)}</s>` : '');

  const opensnel = async (handle, bron) => {
    gekozenBron = bron;
    gekozenVariant = null;
    const inhoud = $('#snelinhoud'), knop = $('#snelToevoegen');
    if (!inhoud) return;
    inhoud.innerHTML = '<p class="mono" style="color:var(--tweede)">Maten ophalen…</p>';
    if (knop) { knop.disabled = true; knop.textContent = 'Kies eerst een maat'; }
    openLaag('snelkopen');

    let p = cache.get(handle);
    if (!p) {
      try {
        const r = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
        p = await r.json();
        cache.set(handle, p);
      } catch (e) {
        inhoud.innerHTML = '<p>Maten konden niet worden opgehaald. Probeer de productpagina.</p>';
        return;
      }
    }

    snelProduct = p;

    let onthouden = null;
    try { onthouden = localStorage.getItem('collett.maat'); } catch (e) {}

    /* Opbouw gelijk aan het paneel dat nu live staat: groot beeld met
       stippen, dan merk, naam en prijs, een haarlijn, "Maat:" en het raster,
       en onderin de mandjeknop met daaronder "Details weergeven". */
    const beelden = (p.images && p.images.length ? p.images : [p.featured_image]).filter(Boolean).slice(0, 6);
    inhoud.innerHTML =
      '<div class="koop">' +
        '<div class="koop__beeld">' +
          (beelden.length
            ? `<img id="koopbeeld" src="${beelden[0]}" alt="" width="600" height="450">`
            : '') +
          (beelden.length > 1
            ? '<div class="koop__stippen" role="tablist" aria-label="Beelden">' +
              beelden.map((b, i) =>
                `<button type="button" role="tab" data-beeld="${b}" aria-label="Beeld ${i + 1}"` +
                ` aria-selected="${i === 0 ? 'true' : 'false'}"></button>`).join('') +
              '</div>'
            : '') +
        '</div>' +
        '<div class="koop__info">' +
          (p.vendor ? `<p class="koop__merk mono">${p.vendor}</p>` : '') +
          `<h3 class="koop__naam">${p.title}</h3>` +
          `<p class="koop__prijs getal${p.compare_at_price && p.compare_at_price > p.price ? ' koop__prijs--sale' : ''}">` +
          snelPrijs(p.price, p.compare_at_price, p.price_varies) +
          '</p>' +
        '</div>' +
        '<p class="koop__maatkop mono">Maat:</p>' +
        '<div class="koop__maten">' + p.variants.map((v) => {
          const kort = (v.title || '').replace(/^EU\s*/i, '').split(' ')[0].split('.')[0];
          const aan = onthouden && kort === onthouden && v.available;
          /* De voorraadstand staat alleen in aria-label: in het vakje zelf
             zou het de maat verdringen. Een uitverkochte maat is geen dode
             knop maar een doorverwijzing naar de productpagina, want daar
             staat het formulier voor een melding bij herbevoorrading. */
          const stand = v.available
            ? (v.inventory_quantity > 0 && v.inventory_quantity <= 3
                ? 'nog ' + v.inventory_quantity + ' beschikbaar' : 'op voorraad')
            : 'uitverkocht, bekijk het paar voor een melding';
          return `<button class="maat" type="button" data-variant="${v.id}"` +
            `${v.available ? '' : ` data-uit data-naar="${p.url}"`}` +
            ` aria-pressed="${aan ? 'true' : 'false'}"` +
            ` aria-label="Maat ${(v.title || '').replace('Default Title', 'Eén maat')} — ${stand}">` +
            `<span>${(v.title || '').replace('Default Title', 'Eén maat')}</span>` +
          '</button>';
        }).join('') + '</div>' +
      '</div>';

    const detail = $('#snelDetails');
    if (detail) { detail.href = p.url; detail.hidden = false; }

    /* een onthouden maat meteen voorselecteren */
    const vooraf = $('.maat[aria-pressed="true"]', inhoud);
    if (vooraf) kiesMaat(vooraf);
  };

  const kiesMaat = (b) => {
    $$('#snelkopen .maat').forEach((m) => m.setAttribute('aria-pressed', String(m === b)));
    gekozenVariant = b.dataset.variant;
    const v = snelProduct && snelProduct.variants.find((x) => String(x.id) === String(gekozenVariant));
    const prijsEl = $('#snelinhoud .koop__prijs');
    if (v && prijsEl) {
      prijsEl.innerHTML = snelPrijs(v.price, v.compare_at_price, false);
      prijsEl.classList.toggle('koop__prijs--sale', !!v.compare_at_price && v.compare_at_price > v.price);
    }
    const knop = $('#snelToevoegen');
    if (knop) { knop.disabled = false; knop.textContent = 'In winkelmandje'; }
  };

  /* Pijlen bij de aanbevolen producten: één kaart per keer opschuiven, en aan
     het eind houdt het op. Ze bleven klikbaar voorbij de laatste kaart, dus je
     scrolde een leeg vlak in (Wessel, 23-10-2026). */
  const aanbodPijlen = () => {
    const rij = $('[data-aanbod-rij]');
    const terug = $('[data-aanbod-terug]');
    const verder = $('[data-aanbod-verder]');
    if (!rij || !terug || !verder) return;
    const rest = rij.scrollWidth - rij.clientWidth - rij.scrollLeft;
    terug.disabled = rij.scrollLeft <= 1;
    verder.disabled = rest <= 1;
  };

  document.addEventListener('click', (e) => {
    const pijl = e.target.closest('[data-aanbod-terug], [data-aanbod-verder]');
    if (!pijl || pijl.disabled) return;
    const rij = $('[data-aanbod-rij]');
    if (!rij) return;
    const stap = rij.clientWidth + 12;
    rij.scrollBy({ left: pijl.hasAttribute('data-aanbod-terug') ? -stap : stap, behavior: 'smooth' });
  });

  /* Ook bij vegen bijwerken, en zodra het mandje opnieuw gerenderd is. */
  document.addEventListener('scroll', (e) => {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-aanbod-rij')) aanbodPijlen();
  }, true);

  /* De stippen onder het beeld wisselen de foto. */
  document.addEventListener('click', (e) => {
    const stip = e.target.closest('#snelkopen [data-beeld]');
    if (!stip) return;
    const beeld = $('#koopbeeld');
    if (beeld) beeld.src = stip.dataset.beeld;
    $$('#snelkopen [data-beeld]').forEach((s2) => s2.setAttribute('aria-selected', String(s2 === stip)));
  });

  /* Alleen de maten in dit paneel. Zonder die afbakening ving deze
     afhandelaar ook de maatvakjes op de productpagina op, die hun eigen
     logica hebben in collett-v3-product.js. */
  document.addEventListener('click', (e) => {
    const m = e.target.closest('#snelkopen .maat');
    if (!m) return;
    if (m.hasAttribute('data-uit')) {
      if (m.dataset.naar) location.href = m.dataset.naar;
      return;
    }
    if (!m.disabled) kiesMaat(m);
  });

  const snelKnop = $('#snelToevoegen');
  if (snelKnop) {
    snelKnop.addEventListener('click', async () => {
      if (!gekozenVariant) return;
      snelKnop.disabled = true;
      snelKnop.textContent = 'Bezig…';
      try {
        const r = await fetch(C.routes.toevoegen, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +gekozenVariant, quantity: 1 }] })
        });
        if (!r.ok) throw new Error(await r.text());
        const bron = gekozenBron;
        const variant = gekozenVariant;
        sluitLaag($('#snelkopen'));
        await haalMandje();
        vlieg(bron);
        toonBevestiging(bron, variant);
      } catch (err) {
        snelKnop.textContent = 'Niet gelukt — probeer de productpagina';
      } finally {
        setTimeout(() => {
          snelKnop.disabled = true;
          snelKnop.textContent = 'Kies eerst een maat';
        }, 600);
      }
    });
  }


  /* ---------------- de productpagina meldt een toevoeging ---------------- */
  document.addEventListener('collett:toegevoegd', async (e) => {
    await haalMandje();
    vlieg(e.detail && e.detail.bron);
    toonBevestiging(e.detail && e.detail.bron, e.detail && e.detail.variant);
  });

  /* ---------------- tegelrij op de collectiepagina (desktop) ----------------
     De rij met merktegels scrolt horizontaal. Met een muis kom je daar niet
     vanzelf bij, en de balk is op desktop verborgen. De pijlen schuiven de
     rij ongeveer één scherm op; aan het eind of het begin staat de pijl uit. */
  const railPijlen = () => {
    const rij = $('#rail');
    const terug = $('[data-rail-pijl="-1"]'), verder = $('[data-rail-pijl="1"]');
    if (!rij || !terug || !verder) return;
    const max = rij.scrollWidth - rij.clientWidth;
    terug.disabled = rij.scrollLeft <= 1;
    verder.disabled = rij.scrollLeft >= max - 1;
  };

  document.addEventListener('click', (e) => {
    const pijl = e.target.closest('[data-rail-pijl]');
    if (!pijl || pijl.disabled) return;
    const rij = $('#rail');
    if (!rij) return;
    rij.scrollBy({ left: Number(pijl.dataset.railPijl) * rij.clientWidth * 0.8,
      behavior: rust ? 'auto' : 'smooth' });
  });

  const railEl = $('#rail');
  if (railEl) {
    railEl.addEventListener('scroll', railPijlen, { passive: true });
    addEventListener('resize', railPijlen);
    railPijlen();
  }

  /* ---------------- start ---------------- */
  haalMandje();
})();
